import { all, call, put, takeLatest } from 'redux-saga/effects'
import { REQUEST_REPORT_LIST, RECEIVE_REPORT_LIST } from '../constants'
import { fetchReportList } from '../services'

function* yieldReportList(action: any) {
  try {
    const response = yield call(fetchReportList, action.payload)
    yield put({ type: RECEIVE_REPORT_LIST, ...response })
    if (action.callback) {
      action.callback(response)
    }
  } catch (err) {
    console.log(err)
  }
}

export function* watchYieldHome() {
  yield all([takeLatest(REQUEST_REPORT_LIST, yieldReportList)])
}



// WEBPACK FOOTER //
// ./src/saga/home.tsx